// Official TechCare Technologies brand assets (see /public/brand). Do not redraw.
const DARK = "/brand/techcare-logo-dark-480.webp";
const DARK_2X = "/brand/techcare-logo-dark-960.webp";
const LIGHT = "/brand/techcare-logo-light-960.webp";
const SYMBOL = "/brand/techcare-symbol.webp";

export const LogoMark = ({ className = "h-9 w-auto", glow = false }) => (
  <span className="relative inline-block">
    {glow && <span aria-hidden="true" className="absolute inset-[-30%] -z-10 rounded-full bg-orange-500/25 blur-2xl" />}
    <img src={SYMBOL} alt="" aria-hidden="true" width="456" height="428" className={`block ${className}`} draggable="false" />
  </span>
);

// variant "dark" = transparent artwork for dark surfaces; "light" = official white-background artwork for white surfaces.
export const Logo = ({ className = "h-12 w-auto", variant = "dark", glow = true }) => (
  <span className="relative inline-flex items-center">
    {variant === "dark" && glow && (
      <span aria-hidden="true" className="pointer-events-none absolute left-[38%] right-[-6%] top-[52%] bottom-[-4%] rounded-[50%] bg-[#5a3a26]/25 blur-2xl" />
    )}
    <img
      src={variant === "light" ? LIGHT : DARK}
      srcSet={variant === "light" ? undefined : `${DARK} 480w, ${DARK_2X} 960w`}
      sizes="(min-width: 1024px) 240px, 160px"
      alt="TechCare Technologies"
      width="1646"
      height="865"
      draggable="false"
      className={`relative block ${className}`}
    />
  </span>
);
